import React from 'react';
import { CaseListLayout } from './CaseListUI';
import FirmOverview from './FirmOverview';

// ---------------------------------------------------------------------------
// Law firms whose profile isn't verified yet and a client already saved their
// firm: the firm overview (stats, saved and AI-recommended cases, short summary
// only) in the case list layout, with every "Request to view more" locked until
// our admin verifies the profile.
// overview = /case/firmOverview data; verified = 2 (under review) | 5 (not approved) | other.
// ---------------------------------------------------------------------------
function UnverifiedSavedCases({ overview, verified }) {
  return (
    <CaseListLayout
      sectionKey="1"
      railItems={[{ key: 'overview', label: 'Overview', icon: 'overview', tip: 'How clients are finding your firm' }]}
      activeKey="overview"
      onSelect={() => {}}
    >
      <FirmOverview mode="unverified" verifiedState={verified} preloaded={overview} />
    </CaseListLayout>
  );
}

export default UnverifiedSavedCases;
